export class RatesTspExt {
    ratesTspId: number;
    controlId: number;
    ratesBidcyclesId: number;
    carrierId: number;
    expiryDate: any;
    additionalInformation: any;
    updateProgram: string;
    updateId: number;    
    updateDate: any;
    scac: any;
    scacName: any;
    rateEffectiveDate: any;
    rateExpiryDate: any;
    rateReleaseDate: any;
    updateEmail: any;
    rateBidcyclesName: any;
}